import produce from 'immer';
import create from 'zustand';

const useWireToolsStore = create(set => ({
  commentLikeHintShown: false,
  set: fn => set(produce(fn)),
}));

export default useWireToolsStore;
